import { useSelector } from 'react-redux';

export function useTribe() {
  const { user } = useSelector((state) => state.auth);

  return user?.tribeId;
}
